import { html } from "lit-element";

export const InspectionListStyles = html`
<style>
    :host {
        height: 100%;
        --db-image-height: 220px;
    }

    .list {
        height: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-content: flex-start;
    }

    .list > .card {
        height: 220px;
        width: 350px;
        margin: 10px;
    }

    .topGroup,
    .nestedGroup {
        width: 100%;
        font-weight: bold;
    }

    .topGroup {
        margin: 14px 0px;
        color: var(--primary-color);
        font-weight: 500;
        font-size: x-large;
        padding: 10px;
        padding-bottom: 0px;
    }

    .nestedGroup {
        border-top: solid var(--secondary-color) 2px;
        margin: 10px 12px;
        padding: 6px;
        color: var(--secondary-color);
    }
    
    .f {
        background-color: var(--primary-color-variant3);
        color: var(--secondary-color);
        position: absolute;
        bottom: 0;
        width: 100%;
        opacity: 0.9;
        display: flex;
        flex-direction: column;
    }

    .h-actions {
        position: absolute;
        top: 0;
        width: 100%;
        padding: 10px;
        text-align: right;
        fill: var(--secondary-color);
    }
    
    .h-actions mwc-button {
        background-color: rgba(255, 255, 255, 0.4);
        border-radius: 5px;
    }

    .nestedGroup  .button {
        display: none;
    }

    @media only screen and (max-width: 460px) {
        .nestedGroup {
            cursor: pointer;
            display: flex;
            justify-content: space-between;
        }

        .nestedGroup .button {
            display: block;
            fill: var(--primary-color);
        }

        .card[collapsed] {
            display: none;
        }

        .list > .card {
            height: 87px;
            width: 100%;
            margin: 5px 10px;
        }
        
        .h-actions {
            background-color: #F0F2F4;
            padding: 8px;
            right: 2px;
            width: unset;
            z-index: 1;
        }

        .h-actions mwc-button {
            background-color: rgba(255, 255, 255, 0.95);
        }

        .list .card .h-image {
            display: none;
        }
        
        .card[id] .f {
            border: 1px solid rgba(0, 0, 255, 0.80);
        }
    }
</style>`;
